var newsletterAllErrors = function(form) {
	var showAllErrorMessages = function() {
		// Find all invalid fields within the form.
		jQuery('.error-msg' , form ).addClass('screen-reader-text').addClass('visuallyhidden');
		var invalidFields = form.find( ":invalid" ).each( function( index, node ) {
			// Find the field's corresponding label
			var label = jQuery( "label[for=" + node.id + "] "),
				// Opera incorrectly does not fill the validationMessage property.
				message = node.validationMessage || jQuery('.error-msg', label).html();

			/*errorList
				.show()
				.append( "<li><span>" + label.html() + "</span> " + message + "</li>" );*/
				jQuery('.error-msg' , label ).html(message).removeClass('screen-reader-text').removeClass('visuallyhidden');
		});
	};

	// Support Safari
	form.on( "submit", function( event ) {
		// console.log(event);
		if ( this.checkValidity && !this.checkValidity() ) {
			jQuery( this ).find( ":invalid" ).first().focus();
			event.preventDefault();
		}
	});

	jQuery( "input[type=submit], button:not([type=button])", form ).on( "click", showAllErrorMessages);

	jQuery( "input", form ).on( "keypress", function( event ) {
		var type = jQuery( this ).attr( "type" );
		if ( /date|email|month|number|search|tel|text|time|url|week/.test ( type )
		  && event.keyCode == 13 ) {
			showAllErrorMessages();
		}
	});
};

jQuery(document).ready(function($) {
	var winWidth = $(window).width();

	$('#ShowSearch, #CloseSearch').click(function(e) {
		$('#SearchOverlay').slideToggle();

		if(e.currentTarget.id === 'ShowSearch') {
			$('#SearchOverlay #s').focus();
			var target = $(this).attr('aria-controls');
			if ($(target).is(':visible') ) {
				$(this).attr('aria-expanded', true);
				$('a:not(.search-link),button:not(.search-link),input:not(.search-link),iframe,textarea:not(.search-link),select:not(.search-link)').attr('aria-hidden', true).attr('tabindex', '-1');
			}
		}
		if (e.currentTarget.id === 'CloseSearch') {
			$('#ShowSearch').attr('aria-expanded', false);
			$('a:not(.search-link),button:not(.search-link),input:not(.search-link),iframe,textarea:not(.search-link),select:not(.search-link)').attr('aria-hidden', false).attr('tabindex', '');
			if ($('html').attr('data-whatinput') == 'keyboard') {
				$('#ShowSearch').focus();
			}
		}

	});

	$('.hamburger').click(function() {
		$(this).toggleClass('is-active');
		$('.desktop-menu').slideToggle();
	});

	$('.nutrition-select').click(function() {
		let index = $(this).data('index');

		$('.nutrition-select').removeClass('active');
		$(this).addClass('active');

		$('.nutrition-item').hide();
		$('.product-index-' + index).css('display', 'flex');
	});

	$('[id^="Accordion_Header"]').on('click', function() {
		var toggleBtn = $(this);
		$(this).toggleClass('open');
		var id =  $(this).attr('id').replace('Accordion_Header_', '');
		$('#Accordion_Content_' + id).slideToggle(function() {
			if (toggleBtn.hasClass('open') ) {
			toggleBtn.attr('aria-expanded', true);
			} else {
			toggleBtn.attr('aria-expanded', false);
			}
		});
	});

	/**
	 * Because of the fixed header, we need to adjust for when an anchor link is used.
	 */
	$(window).on('hashchange load', function() {
		const $anchor = $(':target');
		const fixedElementHeight = 160;

		if ($anchor.length > 0) {

			$('html, body')
			.stop()
			.animate({
				scrollTop: $anchor.offset().top - fixedElementHeight
			}, 280);

		}
	});

	//give all main menu items a custom class for localizing tabbing on mobile
	if ($('.desk-nav-items').length ) {
		$('.desk-nav-items a, .desk-nav-items button').addClass('nav-link');
		if ($('#mobileNavToggle').length) {
			$('#mobileNavToggle').addClass('nav-link');
		}
	}

	//Disable all buttons, submits and links not in the main menu when it's active
	$('#mobileNavToggle').on('click', function() {
		if ($(this).hasClass('is-active') ) {
			$(this).attr('aria-expanded', true);
			$('a:not(.nav-link),button:not(.nav-link),input,textarea,iframe,select').attr('aria-hidden', true).attr('tabindex', '-1');
			$('body').addClass('-mm-open');

		} else {
			$(this).attr('aria-expanded', false);
			$('a:not(.nav-link),button:not(.nav-link),input,textarea,iframe,select').attr('aria-hidden', '').attr('tabindex', '');
			$('body').addClass('-mm-close');
		}
	});

	//add role of button to elementor accordions
	if ($('.elementor-accordion-title').length) {
		$('.elementor-accordion-title').each(function() {
			$(this).attr('role', 'button');
		})
	}

	//contact form 7 invalid messages
	if ($('.wpcf7').length) {
		var wpcf7Elm = document.querySelector( '.wpcf7' );
		wpcf7Elm.addEventListener( 'wpcf7invalid', function( event ) {
			var errorFocus = event.detail.apiResponse.invalid_fields[0].into;
			$(errorFocus + ' .wpcf7-form-control').focus();
		}, false );
	}

	if ($('.mc4wp-alert').length) {
		$('html, body').animate({
			scrollTop: $(".mc4wp-alert").offset().top
		}, 500, function() {
			$(".mc4wp-alert").focus();
		});
	}

	newsletterAllErrors($( "form#mc4wp-form-1" ) );

	$(window).on('resize', function() {
		if (winWidth != $(window).width()) {
			if ($('body').hasClass('-mm-open')) {
				$('body').removeClass('-mm-open');
			}
		}
	});
});
